<script>
    export let row = {};
    import {sgettext} from '../../i18n.js';

    let status = '';

    $: getStatus(row);


    function getStatus(row) {
        status = sgettext(row.template_status);

        if (!row.template) {
            if (row.expired) {
                status = sgettext('$$EXPIRED$$');
            } else if (row.end_time) {
                status = sgettext('$$COMPLETED$$');
            } else if (row.start_time) {
                status = sgettext('$$PROGRESS$$');
            } else {
                status = sgettext('$$NOT_STARTED$$');
            }
        }
    }
</script>

{status}
